module.exports = __webpack_public_path__ + "static/media/complot-bottle.6f7ee34b.png";